module.exports = __webpack_public_path__ + "media/7.abd67281.wav";